/* tslint:disable */
/* eslint-disable */
/**
 * zbo-connector API
 * zbo-connector - client
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
*
* @export
* @enum {string}
*/
export var EnumZboStavPripadu;
(function (EnumZboStavPripadu) {
    EnumZboStavPripadu["NOVY"] = "NOVY";
    EnumZboStavPripadu["NOVY_NACTENO"] = "NOVY_NACTENO";
    EnumZboStavPripadu["ZPRACOVAVANO"] = "ZPRACOVAVANO";
    EnumZboStavPripadu["PRERUSENO"] = "PRERUSENO";
    EnumZboStavPripadu["PRERUSENO_VYZVA"] = "PRERUSENO_VYZVA";
    EnumZboStavPripadu["PREDAVANO_HOM"] = "PREDAVANO_HOM";
    EnumZboStavPripadu["PREVZATO_HOM"] = "PREVZATO_HOM";
    EnumZboStavPripadu["PREDAVANO_TSK"] = "PREDAVANO_TSK";
    EnumZboStavPripadu["PREVZATO_TSK"] = "PREVZATO_TSK";
    EnumZboStavPripadu["K_PODPISU"] = "K_PODPISU";
    EnumZboStavPripadu["ZAMITNUTA"] = "ZAMITNUTA";
    EnumZboStavPripadu["ZNEPLATNENA"] = "ZNEPLATNENA";
    EnumZboStavPripadu["NEVYJADRUJI_SE"] = "NEVYJADRUJI_SE";
    EnumZboStavPripadu["VYRIZENA_KLADNE"] = "VYRIZENA_KLADNE";
    EnumZboStavPripadu["VYRIZENA_NEGATIVNE"] = "VYRIZENA_NEGATIVNE";
    EnumZboStavPripadu["PREDANO_MIMO_SYSTEM"] = "PREDANO_MIMO_SYSTEM";
    EnumZboStavPripadu["ZUK_PREDBEZNE_PROJEDNANO"] = "ZUK_PREDBEZNE_PROJEDNANO";
    EnumZboStavPripadu["ZPRACOVANI_OPP"] = "ZPRACOVANI_OPP";
    EnumZboStavPripadu["ZPRACOVANI_SMLOUVA"] = "ZPRACOVANI_SMLOUVA";
    EnumZboStavPripadu["ZPRACOVANI_PREDBEZ_ZUK"] = "ZPRACOVANI_PREDBEZ_ZUK";
    EnumZboStavPripadu["ZPRACOVANI_SAMSTAN"] = "ZPRACOVANI_SAMSTAN";
    EnumZboStavPripadu["ZPRACOVANI_KOMISE"] = "ZPRACOVANI_KOMISE";
    EnumZboStavPripadu["ZPRACOVANI_ZUK"] = "ZPRACOVANI_ZUK";
    EnumZboStavPripadu["ZPRACOVANI_MIPO"] = "ZPRACOVANI_MIPO";
})(EnumZboStavPripadu || (EnumZboStavPripadu = {}));
//# sourceMappingURL=enum-zbo-stav-pripadu.js.map